import { Provider } from '@angular/core';
import { APP_LOAD } from '@app/core/contracts/app-load';
import { AsmService } from '@asm/features/asm/services/asm.service';

export const agentProviders: Provider[] = [
  {
    provide: APP_LOAD,
    useClass: AsmService,
    multi: true,
  },
];
